import React from 'react';
import styled from 'styled-components';
import { PresetType } from '../../../types/preset';

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

const Description = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0.5rem 0 0;
`;

const TypeOptions = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const TypeOption = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  border: 2px solid ${({ selected }) => (selected ? '#3b82f6' : '#e5e7eb')};
  border-radius: 0.5rem;
  padding: 1.5rem;
  flex: 1;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? '#eff6ff' : '#ffffff')};
  transition: all 0.2s ease-in-out;
  
  &:hover {
    border-color: ${({ selected }) => (selected ? '#3b82f6' : '#d1d5db')};
    background-color: ${({ selected }) => (selected ? '#eff6ff' : '#f9fafb')};
  }
`;

const TypeTitle = styled.h4`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

const TypeDescription = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0.5rem 0 0;
`;

interface TypeSelectionProps {
  onTypeSelect: (type: PresetType) => void;
  currentType: PresetType;
}

const TypeSelectionContainer = styled.div`
  label {
    margin-left: 8px;
  }
`;

const TypeSelection: React.FC<TypeSelectionProps> = ({ onTypeSelect, currentType }) => {
  return (
    <TypeSelectionContainer>
      <StepContainer>
        <div>
          <Title>Choose template type</Title>
          <Description>
            Select the type of template you want to create. This will determine the available options and functionality.
          </Description>
        </div>
        
        <TypeOptions>
          <TypeOption 
            selected={currentType === 'preset'}
            onClick={() => onTypeSelect('preset')}
          >
            <TypeTitle>preSet</TypeTitle>
            <TypeDescription>Single, executable trading action.</TypeDescription>
          </TypeOption>
          
          <TypeOption 
            selected={currentType === 'tradeset'}
            onClick={() => onTypeSelect('tradeset')}
          >
            <TypeTitle>tradeSet</TypeTitle>
            <TypeDescription>Group related preSets for organization.</TypeDescription>
          </TypeOption>
        </TypeOptions>
      </StepContainer>
    </TypeSelectionContainer>
  );
};

export default TypeSelection; 